import { executeRequest, Request } from '@jfs/network'
import { RootStore } from '../../../data/store'
import { combineFirstAndLastName, getNetworkResponseError, isStatusOK } from '../../../util/utill'
import { APIEndPoints } from '../../APIEndPoints'
import { sitConfig } from '../../config'
import { sendEventApi } from '../../sendEvent'
const responseParser = (data: any) => {
  if (!data) {
    throw { message: 'Service is currently unavailable. Please try again later.', code: 'SERVER_ERR_500' }
  }

  // 2. If the server returns HTML instead of JSON (common on 500/Gateway errors)
  if (typeof data === 'string' && data.includes('<html>')) {
     throw { message: 'Technical glitch at server. Please try again.', code: 'HTML_RESPONSE' }
  }

  if (isStatusOK(data)) {
    return data?.data || data
  } else {
    throw getNetworkResponseError(data || { message: 'Unexpected server response' })
  }
}
export const genereteOtpBCApi = (tokens: any, body: any) => {
  let config = sitConfig(tokens) as any
  const baseUserAccessToken = config.headers['x-user-access-token']
  const baseUserIdToken = config.headers['x-userid-token'] // Use the RootStore value, OR fall back to the token that came from the 'tokens' argument
  config.headers['x-user-access-token'] = RootStore?.bcAppInfo?.userAccessToken || baseUserAccessToken
  config.headers['x-userid-token'] = RootStore?.bcAppInfo?.userIdentifier || baseUserIdToken
  let asasas = RootStore.agent.agentInfo
  console.log(`Agent Information ${asasas}`)
  const requestBody = {
    user: {
      mobile: {
        mobileNumber: body?.mobileNumber,
        countryCode: body?.countryCode || '91',
      },
      entityType: 4,
    },
    scope: 'REQUEST',
    authenticateList: [
      {
        mode: 50,
        value: '',
        action: 'generate',
      },
    ],
    purpose: 5,
    extraInfo: RootStore?.agent?.session?.CHANNEL_ID || '',
  }
  const request: Request<{}> = {
    apiPath: APIEndPoints.generateOtpUser,
    method: 'POST',
    config: config,
    body: requestBody,
  }
  sendEventApi(tokens, request, {
    status: 'INITIATED',
  })
  return executeRequest(request)
    .then((data) => {
      return responseParser(data)
    })
    .then((response) => {
      sendEventApi(tokens, request, {
        status: 'SUCCESS',
      })
      return response
    })
    .catch((err) => {
      sendEventApi(tokens, request, {
        status: 'FAILED',
        errorDescription: err,
      })
      throw err
    })
}
